import { gql } from "@/__generated__/gql";

export const STUDENT_LIST_TIME_SERIES = gql(`
  query StudentListTimeSeries(
    $orgId: ID!
    $argument: StudentListTimeSeriesArgumentInput!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        studentListTimeSeries(
          argument: $argument
        ) {
          date
          value
        }
      }
    }
  }`);
